module.exports = "<div class=\"zone \">\n\n    <img src=\"/assets/images/playdots.png\" class=\"dots\">\n    <img src=\"/assets/images/scan2play.png\" class=\"scan\">\n    <img src=\"/assets/images/qr.png\" class=\"qr\" width=\"150\" height=\"150\" alt=\"\">\n\n    <!--\n    <div class=\"wrapper\">\n        <div class=\"focus\">\n            <img src=\"/assets/images/scantoplay.png\" alt=\"\">\n        </div>\n        <div class=\"mask\">\n            <div class=\"text\">SCAN TO PLAY</div>\n        </div>\n    </div>\n-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/views/qr/qr.component.html
// module id = ../../../../../src/app/views/qr/qr.component.html
// module chunks = main